import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {TaskModel} from "../../../models/task.model";
import {ItinerariesTasksSettings} from "../../../../agents/angular/models/itineraries-tasks-settings.model";
import {ServiceTaskTypeEnum} from "../../enum/service-task-type.enum";
import {ServiceType} from "../../../../deliveries/types/service.type";
import * as _ from "lodash";
import {LocationType} from "../../../../commons/types/location.type";
import {VehicleType} from "../../../../commons/types/vehicle.type";
import {GpsPermissionType} from "../../../../agents/types/gps-permission.type";
import {NgxPermissionsService} from "ngx-permissions";

require('./task-item.scss');
@Component({
  standalone: false,
  selector: 'app-task-item',
  templateUrl: './task-item.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskItemComponent implements OnInit, OnChanges {

  @Input() task: TaskModel;
  @Input() disableActions: boolean;
  @Input() analysis: any;
  @Input() taskIndex: number;
  @Input() isSelected: boolean;
  @Input() isHighlighted: boolean;
  @Input() itinerariesTaskSettings: ItinerariesTasksSettings
  @Input() showBundleTaskList: boolean = false;
  @Input() showRelatedTaskList: boolean = false;

  @Output() onTaskSelectToggle = new EventEmitter<string>();
  @Output() clickRelatedTaskListToggleEvent = new EventEmitter<string>();
  @Output() clickBundleTaskListToggleEvent = new EventEmitter<string>();
  @Output() onEditEquippedBound = new EventEmitter<any>();

  public purposeToServiceType: typeof ServiceTaskTypeEnum = ServiceTaskTypeEnum;
  public configZoneId: string;
  public serviceTypes: typeof ServiceType = ServiceType;
  public isDisplayExternal: boolean;
  public internalTaskDayTypes: any;
  public internalTaskRouteTypes: any;
  public internalTaskTypes: any;
  public bundledTaskList: TaskModel[];
  public locationTypes: typeof LocationType = LocationType;
  public taskColorByPurpose: any;
  public bindingSubTask: any;
  public logisticsVehiclesRefList: any[] = [];
  public isShowCopyButton: boolean = false;
  public enableAgentVehicleBinding: boolean;
  public proNumbers: string[] = [];

  constructor(
    @Inject("splitService") private splitService,
    @Inject(NgxPermissionsService) private permissionsService: NgxPermissionsService,
    @Inject('$timeout') private $timeout
  ) {

  }

  ngOnInit() {
    this.internalTaskDayTypes = ['StartDay', 'EndDay'];
    this.internalTaskRouteTypes = ['StartRoute', 'EndRoute'];
    this.internalTaskTypes = ['StartRoute', 'EndRoute', 'StartDay', 'EndDay'];
    this.taskColorByPurpose = {
      Pickup: 'orange-800',
      Dropoff: 'blue-600',
      Operation: 'green-600'
    };

    this.configZoneId = this.splitService.getTimeZone();
    this.isDisplayExternal = this.splitService.getSiteExternalIdConfig();

    if (this.task.bundledTaskList?.length) {
      this.initBundledTaskList(this.task.bundledTaskList);
    }

    this._initProNumbers();

    if (!!this.task.subTasks && (this.task.taskSpec.purpose === 'StartRoute' || this.task.taskSpec.purpose === 'EndRoute')) {

      this.bindingSubTask = _.find(this.task.subTasks, (st) => {
        return _.find(st.actions, (ac) => {
          return ac.type === "VehicleBinding";
        })!!
      })

      this._setLogisticsVehiclesRefList(this.bindingSubTask);
    }

    this.permissionsService.hasPermission('vehicleInstance.logisticsVehicle.update').then((hasPermission) => {
      this.enableAgentVehicleBinding = !!hasPermission && this.splitService.getEnableAgentVehicleBinding();
      this.$timeout(0).then(() => {});
    });

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.task && !changes.task.isFirstChange()) {
      if (this.task.bundledTaskList?.length) {
        this.initBundledTaskList(this.task.bundledTaskList);
      }

      this._initProNumbers();

      if (this.task.subTasks && (this.task.taskSpec.purpose === 'StartRoute' || this.task.taskSpec.purpose === 'EndRoute')) {

        this.bindingSubTask = _.find(this.task.subTasks, (st) => {
          return _.find(st.actions, (ac) => {
            return ac.type === "VehicleBinding";
          })!!
        })

        this._setLogisticsVehiclesRefList(this.bindingSubTask);
      }
    }
  }


  onChangeStatus(task, status) {
    this.task = task;
  }

  isStartEndDay(purpose) {
    return _.includes(this.internalTaskDayTypes, purpose);
  }

  isStartEndRoute(purpose) {
    return _.includes(this.internalTaskRouteTypes, purpose);
  }

  isStartEndDayOrRoute(purpose) {
    return this.isStartEndDay(purpose) || this.isStartEndRoute(purpose);
  }

  onClickRelatedTaskListToggle() {
    this.clickRelatedTaskListToggleEvent.emit(this.task.id);
  }

  onClickBundledTaskListToggle() {
    this.clickBundleTaskListToggleEvent.emit(this.task.id);
  }

  private initBundledTaskList(bundledTaskList) {
    const pickupTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Pickup');
    const dropoffTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Dropoff');
    const operationTasks = bundledTaskList.filter(t => t.taskSpec.purpose === 'Operation');
    this.bundledTaskList = [].concat(pickupTasks, dropoffTasks, operationTasks);
  }

  private _setLogisticsVehiclesRefList(bindingSubTask) {
    this.logisticsVehiclesRefList = [];
    if (!!bindingSubTask) {
      _.forEach(bindingSubTask.actions, (ac) => {
        if (ac.type === "VehicleBinding") {
          const logisticsVehicleReference = _.get(ac, 'logisticsVehicleReference');
          _.get(logisticsVehicleReference, 'vehicleType') === VehicleType.Trailer ?
            this.logisticsVehiclesRefList.push(logisticsVehicleReference) : this.logisticsVehiclesRefList.unshift(logisticsVehicleReference)
        }
      })
    }
  }

  private _initProNumbers() {
    this.proNumbers = [];
    if (this.task.taskType === 'BundledStopover' && this.task.bundledRouteTaskList) {
      const proNumbers = new Set<string>();
      this.task.bundledRouteTaskList.forEach(task => {
        if (task.serviceInfo?.proNumber) {
          proNumbers.add(task.serviceInfo?.proNumber);
        }
      });
      this.proNumbers = Array.from(proNumbers);
    } else if (this.task.serviceInfo?.proNumber) {
      this.proNumbers.push(this.task.serviceInfo?.proNumber);
    }
  }

  protected readonly GpsPermissionType = GpsPermissionType;
}
